 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"HighCharts":"c17536af","chunk-0069ff2e":"84b2f0ea","chunk-05c48500":"c2e8b846","chunk-0a7afad9":"a6e8a835","chunk-17ee2045":"4357343b","chunk-1e1c35c1":"394aee5a","chunk-2d207398":"73897493","chunk-264d486b":"958531ff","chunk-2d0a4c18":"f5125d1e","chunk-2d0ac5dd":"ee6462db","chunk-2d0ae599":"18a23b9a","chunk-2d0b3dcd":"32147083","chunk-2d0b8e0a":"b0d12ab9","chunk-2d0bacb6":"41a297db","chunk-2d0bd5e9":"f6251cc7","chunk-2d0bfed3":"3fda374e","chunk-2d0c04b2":"33f265bd","chunk-2d0c5368":"dfb6363e","chunk-2d0c5398":"01961860","chunk-2d0c840a":"b973d5e1","chunk-2d0cbad6":"36c0b2d6","chunk-2d0cbe59":"4c384c3f","chunk-2d0cc807":"60b99b5f","chunk-2d0ccbc7":"dcee6e31","chunk-2d0cedba":"c906023a","chunk-2d0d3a0a":"ba35f053","chunk-2d0d5c6b":"b470e80b","chunk-2d0d6377":"9378cee9","chunk-2d0da2e7":"fc47006c","chunk-2d0e2123":"e05ea34c","chunk-2d0e6514":"388501f9","chunk-2d207f54":"e66d0c6e","chunk-2d209132":"f639ebcf","chunk-2d20f7a3":"18af4c25","chunk-2d20fae6":"12867ade","chunk-2d216798":"6297ee58","chunk-2d217eb6":"871f10f3","chunk-2d219fca":"480885a3","chunk-2d226159":"e34ca0ed","chunk-2d2268fd":"0127bc8f","chunk-2d2374f7":"7a45fa31","chunk-2d238257":"9b5c2690","chunk-2d238a72":"80a0f722","chunk-2d5809e0":"7d266de0","chunk-2e2f2584":"54e43dd4","chunk-3a93d5b8":"ad8cd86d","chunk-3b18d1ae":"fb41a6c7","chunk-3c1a52a8":"bf961924","chunk-3cd545fe":"0a098ec9","chunk-65cad868":"0e99e77c","chunk-66ae30bc":"21038e53","chunk-4266ff21":"ca235f16","chunk-2d21d826":"a95d2dd2","chunk-59e258b2":"b7e961bb","chunk-1e2fff3d":"5aa51de3","chunk-1ebbf95d":"e4aff4ea","chunk-2e1ee54e":"ab1806eb","chunk-35f059b3":"50bfe002","chunk-4112f612":"612793cb","chunk-116772d7":"802d03bd","chunk-2d82e812":"40ce24ba","chunk-452dcdbd":"3ccbf8af","chunk-486588a2":"7199f3dc","chunk-60c50b88":"a7c90ed8","chunk-90127ed0":"e28b409c","chunk-c238065a":"1644cd07","chunk-cfb5f2b4":"94fc1a33","chunk-f1608220":"6d2dcc79","chunk-f226cff6":"512d38ab","chunk-cdbe2c3a":"c246552e","chunk-575577f2":"45f75eb8","chunk-35f7e25f":"0d4baba0","chunk-4a5f46a6":"735c7b50","chunk-2d0c46e5":"61a21445","chunk-5142d88a":"753b9160","chunk-563d3938":"75aeb30d","AmCharts":"f573e59e","chunk-184bbca6":"85284aa4","chunk-c490784c":"5e592f90","chunk-30fb1d44":"9208f7a9","chunk-59874724":"794b9017","chunk-eb9accdc":"c5706482","chunk-5af2ec7c":"425443eb","chunk-62fe045e":"04312ecc","chunk-64c6ffaa":"ef26fa73","chunk-7482f4d7":"25e43f4b","chunk-78b53006":"e17b7459","chunk-79519c09":"d5da0bd9","chunk-88295540":"4337d3cb","chunk-8829adea":"9e42eccc","chunk-89c08f40":"416c4cce","chunk-99aa14d0":"431c064f","chunk-a36522f4":"fd2f50bf","chunk-af6aabda":"b1b59ef3","ApexChart":"28c8f2e2","chunk-324cadc7":"77038685","chunk-c944c0e8":"62416c4b","chunk-2d21d9f2":"5a1b2512","chunk-d37b5e1e":"6a66fb23","chunk-d4806ca4":"da52ad7d","chunk-89009678":"e6da8dab","chunk-503381c7":"c783d853","chunk-37ec190d":"0247becb","chunk-51aa41c8":"62aec333","chunk-5bdf3f48":"bdad43b7","chunk-ab6031ce":"bc11e997","chunk-6702d666":"26a6d020","chunk-17015ef3":"d229993c","chunk-ac52438e":"531bae01","chunk-a75eccee":"b7ac2ceb","chunk-dda060aa":"d9d455f8","chunk-ef8f5022":"f7286b29","chunk-713ce74e":"c269c88c","canvg":"7e86f843","pdfmake":"635ea030","xlsx":"e4f5802c","chunk-2d2222f9":"c07df1a2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0069ff2e":1,"chunk-05c48500":1,"chunk-3b18d1ae":1,"chunk-3cd545fe":1,"chunk-65cad868":1,"chunk-4266ff21":1,"chunk-59e258b2":1,"chunk-1e2fff3d":1,"chunk-116772d7":1,"chunk-60c50b88":1,"chunk-5142d88a":1,"chunk-184bbca6":1,"chunk-59874724":1,"chunk-79519c09":1,"chunk-99aa14d0":1,"chunk-d4806ca4":1,"chunk-89009678":1,"chunk-503381c7":1,"chunk-37ec190d":1,"chunk-51aa41c8":1,"chunk-5bdf3f48":1,"chunk-ab6031ce":1,"chunk-6702d666":1,"chunk-17015ef3":1,"chunk-ac52438e":1,"chunk-a75eccee":1,"chunk-ef8f5022":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"HighCharts":"31d6cfe0","chunk-0069ff2e":"374a13c2","chunk-05c48500":"5405d2da","chunk-0a7afad9":"31d6cfe0","chunk-17ee2045":"31d6cfe0","chunk-1e1c35c1":"31d6cfe0","chunk-2d207398":"31d6cfe0","chunk-264d486b":"31d6cfe0","chunk-2d0a4c18":"31d6cfe0","chunk-2d0ac5dd":"31d6cfe0","chunk-2d0ae599":"31d6cfe0","chunk-2d0b3dcd":"31d6cfe0","chunk-2d0b8e0a":"31d6cfe0","chunk-2d0bacb6":"31d6cfe0","chunk-2d0bd5e9":"31d6cfe0","chunk-2d0bfed3":"31d6cfe0","chunk-2d0c04b2":"31d6cfe0","chunk-2d0c5368":"31d6cfe0","chunk-2d0c5398":"31d6cfe0","chunk-2d0c840a":"31d6cfe0","chunk-2d0cbad6":"31d6cfe0","chunk-2d0cbe59":"31d6cfe0","chunk-2d0cc807":"31d6cfe0","chunk-2d0ccbc7":"31d6cfe0","chunk-2d0cedba":"31d6cfe0","chunk-2d0d3a0a":"31d6cfe0","chunk-2d0d5c6b":"31d6cfe0","chunk-2d0d6377":"31d6cfe0","chunk-2d0da2e7":"31d6cfe0","chunk-2d0e2123":"31d6cfe0","chunk-2d0e6514":"31d6cfe0","chunk-2d207f54":"31d6cfe0","chunk-2d209132":"31d6cfe0","chunk-2d20f7a3":"31d6cfe0","chunk-2d20fae6":"31d6cfe0","chunk-2d216798":"31d6cfe0","chunk-2d217eb6":"31d6cfe0","chunk-2d219fca":"31d6cfe0","chunk-2d226159":"31d6cfe0","chunk-2d2268fd":"31d6cfe0","chunk-2d2374f7":"31d6cfe0","chunk-2d238257":"31d6cfe0","chunk-2d238a72":"31d6cfe0","chunk-2d5809e0":"31d6cfe0","chunk-2e2f2584":"31d6cfe0","chunk-3a93d5b8":"31d6cfe0","chunk-3b18d1ae":"4604ae75","chunk-3c1a52a8":"31d6cfe0","chunk-3cd545fe":"5a99114f","chunk-65cad868":"0080140f","chunk-66ae30bc":"31d6cfe0","chunk-4266ff21":"3a314ea4","chunk-2d21d826":"31d6cfe0","chunk-59e258b2":"9a4fb684","chunk-1e2fff3d":"32ce1d3a","chunk-1ebbf95d":"31d6cfe0","chunk-2e1ee54e":"31d6cfe0","chunk-35f059b3":"31d6cfe0","chunk-4112f612":"31d6cfe0","chunk-116772d7":"610e9673","chunk-2d82e812":"31d6cfe0","chunk-452dcdbd":"31d6cfe0","chunk-486588a2":"31d6cfe0","chunk-60c50b88":"941a6462","chunk-90127ed0":"31d6cfe0","chunk-c238065a":"31d6cfe0","chunk-cfb5f2b4":"31d6cfe0","chunk-f1608220":"31d6cfe0","chunk-f226cff6":"31d6cfe0","chunk-cdbe2c3a":"31d6cfe0","chunk-575577f2":"31d6cfe0","chunk-35f7e25f":"31d6cfe0","chunk-4a5f46a6":"31d6cfe0","chunk-2d0c46e5":"31d6cfe0","chunk-5142d88a":"3e7622d9","chunk-563d3938":"31d6cfe0","AmCharts":"31d6cfe0","chunk-184bbca6":"e9c25f04","chunk-c490784c":"31d6cfe0","chunk-30fb1d44":"31d6cfe0","chunk-59874724":"f2172597","chunk-eb9accdc":"31d6cfe0","chunk-5af2ec7c":"31d6cfe0","chunk-62fe045e":"31d6cfe0","chunk-64c6ffaa":"31d6cfe0","chunk-7482f4d7":"31d6cfe0","chunk-78b53006":"31d6cfe0","chunk-79519c09":"9db3d878","chunk-88295540":"31d6cfe0","chunk-8829adea":"31d6cfe0","chunk-89c08f40":"31d6cfe0","chunk-99aa14d0":"588f018f","chunk-a36522f4":"31d6cfe0","chunk-af6aabda":"31d6cfe0","ApexChart":"31d6cfe0","chunk-324cadc7":"31d6cfe0","chunk-c944c0e8":"31d6cfe0","chunk-2d21d9f2":"31d6cfe0","chunk-d37b5e1e":"31d6cfe0","chunk-d4806ca4":"bf2fa43d","chunk-89009678":"92647ec0","chunk-503381c7":"a2e03004","chunk-37ec190d":"92647ec0","chunk-51aa41c8":"92647ec0","chunk-5bdf3f48":"92647ec0","chunk-ab6031ce":"92647ec0","chunk-6702d666":"7b8fa24c","chunk-17015ef3":"e7af7d36","chunk-ac52438e":"edb4e669","chunk-a75eccee":"d153a058","chunk-dda060aa":"31d6cfe0","chunk-ef8f5022":"b24dc85e","chunk-713ce74e":"31d6cfe0","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0","chunk-2d2222f9":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-563d3938","AmCharts","chunk-c490784c","ApexChart","HighCharts"]]);
 	return startupResult;
